<div class="card-body">

  <form>

    <div class="row">

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Responsible Calibration Technician</label>
        <select class="custom-select" [(ngModel)]="Selection_KarshnasMasol_Id" name="Selection_KarshnasMasol_Id">
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_KarshnasMasol" [value]="item.id">
            <span *ngIf="item.sex==1">Mr.</span>
            <span *ngIf="item.sex==0">Ms.</span>
            {{item.fname}} {{item.lname}}
          </option>

        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Communication Method Type</label>
        <select class="custom-select" (change)="Read_Karshenash_Link()" [(ngModel)]="Selection_KarshnasMasol_Link"
          name="Selection_KarshnasMasol_Link">
          <option value="0">Select</option>
          <option value="1">Mobile Number</option>
          <option value="2">Phone</option>
          <option value="3">Email </option>
        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Communication Method</label>
        <select class="custom-select" [(ngModel)]="Selection_KarshnasMasol_Link_Dsc"
          name="Selection_KarshnasMasol_Link_Dsc">
          <option value="">Select</option>
          <option *ngFor="let item of DataList_KarshnasMasol_link" [value]="item">{{item}}</option>

        </select>
      </div>

    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Conversation Summary</label>
        <textarea class="form-control" [(ngModel)]="Selection_Dsc" name="Selection_Dsc"
          placeholder="Type here..."></textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">
          Attachments
          <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
              class="fa  fa-times-rectangle"></i> </button>
        </label>
        <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
        <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
          class="form-control" placeholder="Type here...">
      </div>
      <div class="form-group col-md-6">
        <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info"
          style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>
      </div>
    </div>

    <div class="table-responsive" *ngIf="file_uploaded_src.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #3e399b; color: white;">
          <tr>
            <th>#</th>
            <th>File</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let itemFile of file_uploaded_src">

            <td>{{file_uploaded_src.indexOf(itemFile)+1}}</td>
            <td>

              <a target="_blank" *ngIf="itemFile.includes('.pdf')" href="{{BaseURlFile}}File/Letter/{{itemFile}}"
                class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>


              <img *ngIf="!itemFile.includes('.pdf')" (click)="openModal(templateImage,itemFile)"
                style="width: 150px;cursor: zoom-in;" src="{{BaseURlFile}}File/Letter/{{itemFile}}" />
            </td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;"
                      (click)="UploadImageSrc_List_Delete(file_uploaded_src.indexOf(itemFile),item)"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <br />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="OnSubmit()" type="button" class="btn btn-success"
      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>

    <button *ngIf="!InProccessing" (click)="Read_Karshenash_Masole()" type="button" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa fa-refresh"></i> Refresh</button>


  </form>



</div>

<ng-template #templateImageForm>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> File Upload Form </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ImageForm.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">
        Attachments
        <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
            class="fa  fa-times-rectangle"></i> </button>
      </label>
      <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
      <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
        class="form-control" placeholder="Type here...">
    </div>
  </div>
  <div class="modal-footer">

    <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ImageForm.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>